/* eslint-disable import/prefer-default-export */
export const useFile = {
  marginTop: 70,
}
